'use client';

import { FC, useEffect, useState } from 'react';
import { Promo18CheckStoryblok } from 'storyblok-types';
import { Button } from 'atoms/Button';
import { IButton } from 'atoms/Button/types';
import { Container } from 'atoms/Container';
import { Image } from 'atoms/Image/Image';
import { Link } from 'atoms/Link/Link';
import { renderLink } from 'atoms/StoryBlokLink';
import { HeadLine } from 'atoms/Typography/Typography';
import { RichTextMarkdown } from 'pages/StoryBlok/RichText';
import styles from './Promo18Check.module.css';

export const Promo18Check: FC<{ blok: Promo18CheckStoryblok }> = ({ blok }) => {
  const [searchParams, setSearchParams] = useState<string>('');
  const { image, text, buttons, links } = blok;

  useEffect(() => {
    setSearchParams(window.location.search);
  }, []);

  return (
    <Container className={styles.container}>
      <div className={styles.wrapper}>
        <Image
          src={image?.filename}
          alt={image?.alt}
          className={styles.image}
        />
        <div className={styles.content}>
          <RichTextMarkdown
            text={text}
            components={{
              h2: ({ children }) => (
                <HeadLine
                  type="sm"
                  tag="h2"
                  weight="bold"
                  color="purple"
                  className={styles.title}
                >
                  {children}
                </HeadLine>
              ),
            }}
          />
          <div className={styles.buttons}>
            {buttons?.map(({ value, _uid, href, color }) => (
              <Button
                key={_uid}
                href={href + searchParams}
                color={color as IButton['color']}
                className={styles.button}
              >
                {value}
              </Button>
            ))}
          </div>

          <div className={styles.links}>
            {links?.map((link) => (
              <span key={link._uid} className={styles.linkWrapper}>
                <Link
                  className={styles.link}
                  target={link.parameters?.target}
                  href={renderLink(link.parameters) + searchParams}
                >
                  {link.text}
                </Link>
              </span>
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
};
